import React, { Component } from "react";
import { Grid, Typography } from "@mui/material";
import CtBtn from "./CustomTool/CtBtn";
import CtCmb from "./CustomTool/CtCmb";
import CtTxt from "./CustomTool/CtTxt";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import { withRouter } from "../HOC/withRouter";
import { connect } from "react-redux";
import {
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps,
} from "../mapRedux/mapReduxProps";

import "./AMCList.css";

/* ================== HELPER FUNCTION ================== */
const getDefaultFilterRow = (id) => ({
  id,
  field: "",
  operation: "",
  value: "",
  condition: "",
});

/* ================== COMPONENT ================== */
class AMCFilter extends Component {
  state = {
    formData: {},
    filterRows: [
      getDefaultFilterRow(1),
      getDefaultFilterRow(2),
      getDefaultFilterRow(3),
    ],
    filterFieldOptions: [
      { value: "Branch" },
      { value: "Site" },
      { value: "Contract Type" },
      { value: "Payment Type" },
    ],
    filterOperationOptions: [
      { value: "=" },
      { value: "!=" },
      { value: "LIKE" },
      { value: ">" },
      { value: "<" },
    ],
    filterConditionOptions: [{ value: "AND" }, { value: "OR" }],
  };

  // componentDidMount() {
  //   document.title = "Top India Elevator : AMC Filter";
  //   document.getElementById("`field-${row.id}`").focus();
  // }
  componentDidMount() {
    document.title = "Top India Elevator : AMC Filter";

    setTimeout(() => {
      const firstRowId = this.state.filterRows[0]?.id;
      if (firstRowId) {
        const el = document.getElementById(`field-${firstRowId}`);
        if (el) el.focus();
      }
    }, 200);
  }

  /* ================== HANDLERS ================== */

  addFilterRow = () => {
    this.setState((prev) => ({
      filterRows: [...prev.filterRows, getDefaultFilterRow(Date.now())],
    }));
  };

  removeFilterRow = (id) => {
    this.setState(
      (prev) => ({
        filterRows: prev.filterRows.filter((row) => row.id !== id),
      }),
      () => {
        const firstRow = this.state.filterRows[0];
        if (firstRow) {
          const firstField = document.getElementById(`field-${firstRow.id}`);
          if (firstField) {
            firstField.focus();
          }
        }
      },
    );
  };

  handleFilterRowChange = (id, field, value) => {
    this.setState((prev) => ({
      filterRows: prev.filterRows.map((row) =>
        row.id === id ? { ...row, [field]: value } : row,
      ),
    }));
  };

  /* ================== RENDER ================== */

  render() {
    const { filterRows } = this.state;

    return (
      <Grid container justifyContent="flex-start" direction="row">
        {/* ---------- HEADER ---------- */}
        <Typography
          style={{ fontSize: "30px", fontWeight: 600, marginBottom: 10 }}
        >
          AMC Filter
        </Typography>

        {/* ---------- ADD FILTER BUTTON ---------- */}
        <Grid container spacing={2} justifyContent="flex-start" direction="row">
          <Grid item>
            <CtBtn
              label="Add Filter"
              iconName="new"
              firstletterBig={false}
              className="secondary-button"
              onClick={this.addFilterRow}
            />
          </Grid>
        </Grid>

        {/* ---------- FILTER ROWS ---------- */}
        <Grid container marginTop={2}>
          {filterRows.map((row, index) => {
            const isLastRow = index === filterRows.length - 1;
            const fieldWidth = 120;

            return (
              <Grid
                container
                spacing={2}
                key={row.id}
                alignItems="flex-end"
                marginTop={1}
              >
                {/* FIELD */}
                <Grid item>
                  <CtCmb
                    id={`field-${row.id}`}
                    label={`Field ${index + 1}`}
                    items={this.state.filterFieldOptions}
                    value={row.field}
                    handleOnChange={(e) =>
                      this.handleFilterRowChange(
                        row.id,
                        "field",
                        e.target.value,
                      )
                    }
                    colID="value"
                    width={fieldWidth}
                  />
                </Grid>

                {/* OPERATION */}
                <Grid item>
                  <CtCmb
                    id={`op-${row.id}`}
                    label="Operation"
                    items={this.state.filterOperationOptions}
                    value={row.operation}
                    handleOnChange={(e) =>
                      this.handleFilterRowChange(
                        row.id,
                        "operation",
                        e.target.value,
                      )
                    }
                    colID="value"
                    width={fieldWidth}
                  />
                </Grid>

                {/* VALUE */}
                <Grid item xs={12} sm={3}>
                  <CtTxt
                    id={`val-${row.id}`}
                    label="Value"
                    value={row.value}
                    handleOnChange={(e) =>
                      this.handleFilterRowChange(
                        row.id,
                        "value",
                        e.target.value,
                      )
                    }
                    width={fieldWidth}
                  />
                </Grid>

                {/* CONDITION */}
                <Grid item xs={12} sm={2}>
                  {!isLastRow && (
                    <CtCmb
                      id={`cond-${row.id}`}
                      label="Condition"
                      items={this.state.filterConditionOptions}
                      value={row.condition}
                      handleOnChange={(e) =>
                        this.handleFilterRowChange(
                          row.id,
                          "condition",
                          e.target.value,
                        )
                      }
                      colID="value"
                      width={fieldWidth}
                    />
                  )}
                </Grid>

                {/* DELETE ICON */}
                <Grid
                  item
                  // xs={12}
                  sm={1}
                  sx={{
                    width: "50px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {filterRows.length > 1 && isLastRow && (
                    <CtBtn
                      label=""
                      className="delete-button"
                      iconName="delete"
                      onClick={() => this.removeFilterRow(row.id)}
                    >
                      {/* <DeleteOutlineIcon /> */}
                    </CtBtn>
                  )}
                </Grid>
              </Grid>
            );
          })}
        </Grid>

        {/* ---------- APPLY BUTTON ---------- */}
        <Grid container spacing={2} marginTop={2} justifyContent="center">
          <Grid item>
            <CtBtn
              label="Apply Filter"
              firstletterBig={false}
              className="secondary-button"
              width={160}
              onClick={() =>
                console.log("Applied Filters:", this.state.filterRows)
              }
            />
          </Grid>
        </Grid>
      </Grid>
    );
  }
}

/* ================== EXPORT ================== */
export default connect(
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps,
)(HOCVerifyIsUser(HoCtToastContainer(withRouter(AMCFilter))));
